import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

/**
 * État d'erreur : affiché quand une requête a échoué.
 *
 * Règle du projet : une erreur réseau ne doit JAMAIS être remplacée par des
 * données fictives. On dit à l'utilisateur que ça a échoué et on lui donne un
 * moyen de réessayer.
 */
@Component({
  selector: 'app-error-state',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './error-state.component.html',
  styleUrl: './error-state.component.css',
})
export class ErrorStateComponent {
  /** Clé i18n du titre. */
  @Input() titleKey = 'COMMON.ERROR_TITLE';

  /** Clé i18n du message explicatif. */
  @Input() messageKey = 'COMMON.ERROR_MESSAGE';

  /** Détail technique optionnel (statut HTTP, message serveur). */
  @Input() detail = '';

  /** Masquer le bouton « Réessayer » quand l'action n'a pas de sens. */
  @Input() retryable = true;

  @Output() retry = new EventEmitter<void>();
}
